export default "__VITE_ASSET__Dp9dn9my__"